import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "../../style/controls/contrastRatio.scss";
import { useMemo } from "react";
import { A11yNotice } from "./notice.js";
import { useA11yDispatcher } from "../../hooks/useA11yDispatcher.js";
import { useCustomizeValues } from "../../hooks/useCustomizeValues.js";
import { getSidebarCustomize } from "../../sidebar/getSidebarCustomize.js";
import { getLuminosityRatio } from "../../utils/getLuminosityRatio.js";
import { __ } from "../../utils/i18n.js";
const A11yContrastRatio = ({ settings, severity, minimumRatio, renderNotice, modifier })=>{
    const customize = getSidebarCustomize();
    const values = useCustomizeValues(settings);
    // Calculate luminosity ratio
    const ratio = useMemo(()=>{
        const [color1, color2] = modifier ? modifier(settings.slice(0, 2).reduce((p, c)=>{
            p.push(values[c].value);
            return p;
        }, []), settings.slice(2).reduce((p, c)=>{
            p.push(values[c].value);
            return p;
        }, []), (setting)=>customize(setting).get()) : [
            values[settings[0]].value,
            values[settings[1]].value
        ];
        return getLuminosityRatio(color1, color2);
    }, [
        JSON.stringify(values)
    ]);
    const renderedNotice = renderNotice?.(ratio, minimumRatio);
    const hasError = ratio < minimumRatio;
    useA11yDispatcher({
        setting: settings[1],
        valid: !hasError
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("strong", {
                children: __("Contrast ratio:")
            }),
            "\xa0",
            ratio.toFixed(2),
            hasError && (renderedNotice ? /*#__PURE__*/ _jsx("div", {
                className: `notice notice-${severity} inline below-h2 notice-alt`,
                style: {
                    margin: "10px 0"
                },
                children: /*#__PURE__*/ _jsx("p", {
                    children: renderedNotice
                })
            }) : /*#__PURE__*/ _jsx(A11yNotice, {
                severity: severity,
                text: __('We recommend a contrast ratio between background and font color of at least %f to comply with the {{aPerc}}"perceptibility" of the WCAG 2.2 standard{{/aPerc}} and thereby meet the {{aEuMinimum}}EU\'s minimum legal requirements for accessibility{{/aEuMinimum}}.', minimumRatio)
            }))
        ]
    });
};
export { A11yContrastRatio };
